module.exports = __webpack_public_path__ + "uz.svg?d9b782092304b93fa203f2e84a9a5c60";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/uz.svg
// module id = 1678
// module chunks = 0